var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg8664831UserIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.522,
    height: 16.597,
    viewBox: "0 0 14.522 16.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_8664831_user_icon",
    "data-name": "8664831_user_icon",
    d: "M8.817,9.855H5.705A5.705,5.705,0,0,0,0,15.56,1.037,1.037,0,0,0,1.037,16.6H13.485a1.037,1.037,0,0,0,1.037-1.037A5.705,5.705,0,0,0,8.817,9.855ZM1.588,15.041a4.154,4.154,0,0,1,4.117-3.631H8.817a4.156,4.156,0,0,1,4.117,3.631ZM7.261,8.3A4.149,4.149,0,1,0,3.112,4.149,4.149,4.149,0,0,0,7.261,8.3Zm0-6.743A2.593,2.593,0,1,1,4.668,4.149,2.6,2.6,0,0,1,7.261,1.556Z",
    fill: "#6d4eec"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8664831UserIcon);
export default __webpack_public_path__ + "static/media/8664831_user_icon.9f8ab496a35d7f86700b43ae8c66a5b8.svg";
export { ForwardRef as ReactComponent };